import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'

class Tooltip {
  setDefault() {
    tippy.setDefaultProps({ theme: 'light-border', arrow: true, offset: [0, 15] })
  }
}

export default Tooltip
